const topics = [
  { label: '动作大片', count: '2.3w', hot: true, icon: 'ri-fire-fill' },
  { label: '科幻巨制', count: '1.8w', hot: true, icon: 'ri-rocket-2-fill' },
  { label: '喜剧精选', count: '1.5w', hot: false, icon: 'ri-emotion-laugh-fill' },
  { label: '悬疑烧脑', count: '1.2w', hot: true, icon: 'ri-magic-fill' },
  { label: '爱情经典', count: '9.8k', hot: false, icon: 'ri-heart-fill' },
  { label: '战争史诗', count: '7.6k', hot: false, icon: 'ri-sword-fill' },
  { label: '动画佳作', count: '8.9k', hot: true, icon: 'ri-star-fill' },
  { label: '恐怖惊悚', count: '6.5k', hot: false, icon: 'ri-ghost-fill' },
  { label: '纪录精选', count: '4.2k', hot: false, icon: 'ri-camera-fill' },
  { label: '华语热播', count: '3.1w', hot: true, icon: 'ri-china-railway-fill' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          大家都在关注的电影类型，发现你的观影兴趣
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <a
              key={t.label}
              href="#index"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 group bg-background-50 border-background-200/70 hover:border-primary-300"
            >
              <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs ${t.hot ? 'bg-primary-100 text-primary-600' : 'bg-secondary-100 text-secondary-600'}`}>
                <i className={t.icon}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                {t.label}
              </span>
              <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${t.hot ? 'bg-primary-50 text-primary-600' : 'bg-secondary-50 text-secondary-500'}`}>
                {t.count}
              </span>
              {t.hot && (
                <span className="text-[10px] text-accent-600 font-bold bg-accent-50 px-1 rounded">热</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}